import React, { useState, useEffect, useCallback } from 'react';
import { yonetim } from '../api';
import { tarihSaat } from '../yardimcilar';

// Bilinen parametreler için okunaklı Türkçe adlar (yoksa anahtar gösterilir).
const ETIKETLER = {
  TalepSuresiDakika: 'Talep süresi (dakika)',
  TeklifAdediLimiti: 'Teklif adedi limiti',
  TalepBasinaRandevuLimiti: 'Talep başına randevu limiti',
  RandevuGecerlilikSaati: 'Randevu geçerlilik süresi (saat)',
  TeklifGecerlilikSaati: 'Teklif geçerlilik süresi (saat)',
  KategoriBasinaAktifTalep: 'Kategori başına aktif talep',
  BildirimSaklamaGun: 'Bildirim saklama (gün)',
  SmsBeklemeSaniye: 'SMS bekleme (saniye)',
  AnasayfaKampanyaSayisi: 'Anasayfa kampanya sayısı',
  PanomAktifTalepSayisi: 'Panom aktif talep sayısı',
};

function Satir({ p, onKaydet }) {
  const [deger, setDeger] = useState(p.deger);
  const [kaydediliyor, setKaydediliyor] = useState(false);
  const [hata, setHata] = useState('');
  const degisti = deger !== p.deger;

  async function kaydet() {
    setHata('');
    setKaydediliyor(true);
    try {
      await onKaydet(p.anahtar, deger);
    } catch (e) {
      setHata(e.message);
      setDeger(p.deger);
    } finally {
      setKaydediliyor(false);
    }
  }

  return (
    <tr>
      <td>
        <strong>{ETIKETLER[p.anahtar] || p.anahtar}</strong>
        <div style={{ color: '#888', fontSize: 12 }}>{p.aciklama || p.anahtar}</div>
        {hata && <div style={{ color: '#dc2626', fontSize: 12 }}>{hata}</div>}
      </td>
      <td style={{ width: 160 }}>
        <input value={deger} onChange={(e) => setDeger(e.target.value)}
          style={{ padding: 8, border: '1px solid #ddd', borderRadius: 8, width: '100%' }} />
      </td>
      <td style={{ color: '#888', fontSize: 12 }}>{tarihSaat(p.guncellemeUtc)}</td>
      <td style={{ textAlign: 'right' }}>
        <button className="btn btn-primary btn-sm" disabled={!degisti || kaydediliyor} onClick={kaydet}>
          {kaydediliyor ? 'Kaydediliyor…' : 'Kaydet'}
        </button>
      </td>
    </tr>
  );
}

export default function Parametreler() {
  const [liste, setListe] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [hata, setHata] = useState('');
  const [basari, setBasari] = useState('');

  const yukle = useCallback(async () => {
    setYukleniyor(true);
    setHata('');
    try {
      setListe(await yonetim.parametreler());
    } catch (e) {
      setHata(e.message);
    } finally {
      setYukleniyor(false);
    }
  }, []);

  useEffect(() => { yukle(); }, [yukle]);

  async function kaydet(anahtar, deger) {
    await yonetim.parametreGuncelle(anahtar, deger);
    setBasari(`"${ETIKETLER[anahtar] || anahtar}" güncellendi.`);
    setListe((l) => l.map((p) => (p.anahtar === anahtar ? { ...p, deger, guncellemeUtc: new Date().toISOString() } : p)));
    setTimeout(() => setBasari(''), 2500);
  }

  return (
    <div>
      <div className="page-header">
        <h1>Parametreler</h1>
        <p>Sistem parametrelerini görüntüleyin ve güncelleyin</p>
      </div>

      {hata && <div className="mesaj hata">{hata}</div>}
      {basari && <div className="mesaj basari">{basari}</div>}

      <div className="card tablo-kart">
        <table>
          <thead>
            <tr>
              <th>Parametre</th>
              <th>Değer</th>
              <th>Son güncelleme</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {liste.map((p) => (
              <Satir key={p.anahtar} p={p} onKaydet={kaydet} />
            ))}
            {yukleniyor && <tr><td colSpan={4} className="yukleniyor">Yükleniyor…</td></tr>}
            {!yukleniyor && liste.length === 0 && <tr><td colSpan={4} className="bos">Parametre bulunamadı.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
